import { render, staticRenderFns } from "./commentModal.vue?vue&type=template&id=b2455212&scoped=true"
import script from "./commentModal.vue?vue&type=script&lang=js"
export * from "./commentModal.vue?vue&type=script&lang=js"
import style0 from "./commentModal.vue?vue&type=style&index=0&id=b2455212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2455212",
  null
  
)

export default component.exports